import { z } from 'zod'

export const AccessProviderSchema = z.enum(['cloudflare', 'turnstile'])
export type AccessProvider = z.infer<typeof AccessProviderSchema>
export const AccessBlockerSchema = z.object({
  provider: AccessProviderSchema,
  url: z.string().url().max(4000).refine(value => /^https?:\/\//i.test(value), 'A web URL is required'),
  detail: z.string().trim().min(1).max(2000),
})
export type AccessBlocker = z.infer<typeof AccessBlockerSchema>
export const AccessRequestSchema = AccessBlockerSchema.extend({
  id: z.string(),
  task_id: z.string(),
  expires_at: z.string(),
})
export type AccessRequest = z.infer<typeof AccessRequestSchema>
export const ProjectAccessSchema = z.object({
  requests: z.array(AccessRequestSchema),
})
export type ProjectAccess = z.infer<typeof ProjectAccessSchema>
export const ProjectAccessMutationSchema = z.discriminatedUnion('action', [
  z.object({ action: z.literal('answer'), project_id: z.string().min(1), request_id: z.string().min(1), value: z.literal('') }).strict(),
])
export const TaskAccessMutationSchema = z.discriminatedUnion('action', [
  AccessBlockerSchema.extend({ action: z.literal('request'), wait_seconds: z.number().int().min(1).max(600).default(600) }).strict(),
  z.object({ action: z.literal('poll'), request_id: z.string().min(1) }).strict(),
  z.object({ action: z.literal('expire'), request_id: z.string().min(1) }).strict(),
])
export const AccessPollSchema = z.object({ resolved: z.boolean(), value: z.string().nullable(), expired: z.boolean() })
export const AccessRequestResponseSchema = z.object({ request: AccessRequestSchema })
export const AccessSuccessSchema = z.object({ ok: z.literal(true) })
